import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import {IconButton, IconButtonProps, Tooltip} from '@mui/material';
import {useState} from 'react';
import {HelpButtonDialog, HelpButtonDialogProps} from './HelpButtonDialog';

export interface HelpButtonProps
  extends
    Omit<IconButtonProps, 'onClick' | 'title'>,
    Pick<HelpButtonDialogProps, 'description' | 'videoUrl'>,
    Partial<Pick<HelpButtonDialogProps, 'title'>> {}

export default function HelpButton({description, videoUrl, title, ...props}: HelpButtonProps) {
  const [open, setOpen] = useState(false);

  if (!title) {
    return null;
  }

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Tooltip title={description}>
        {}
        <IconButton onClick={handleClick} {...props}>
          <HelpOutlineIcon />
        </IconButton>
      </Tooltip>

      <HelpButtonDialog open={open} onClose={handleClose} title={title} description={description} videoUrl={videoUrl} />
    </>
  );
}
